<template>
  <div class="animated fadeIn">
    <b-modal  ref="modal-bloquear-ajuizamento" centered button-size="sm" v-on:hide="hideModal" v-on:close="hideModal">
      <template #modal-title>
        <i class="fas fa-lock"></i>&nbsp; BLOQUEAR AJUIZAMENTO
      </template>
      <div class="col-md-12">
        <label for="txtGroup">
          Máximo de dias de atraso:
        </label>
        <div class="input-group">
          <NxInput
            validation="min:0"
            :validation-messages="{
                      min: 'Valor não pode ser negativo.'
                  }"
            error-behavior="value"
            required
            name="timeLimit"
            type="number"
            placeholder="Digite o tempo limite"
            :value="form.diasAtrasoProdutoCard.value"
            v-model="form.diasAtrasoProdutoCard.value">
          </NxInput>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn rounded btn-default btn-sm text-secundary" v-on:click="onClear"
                  v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonClear"><i class="fa fa-minus-circle mr-1"></i>
            <span class="d-md-down-none">{{ $lang.Common.Buttons.Clear }}</span></button>&nbsp;
          <button type="button" class="btn rounded btn-third btn-sm" v-on:click="saveAndClose"> <i class="fa fa-check mr-1"></i> <span class="d-md-down-none">Salvar</span></button>&nbsp;
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import ModalBlockAjuizamentoForm from './ModalBlockAjuizamento-form'

const dataBlockAjuizamento = {
  diasAtraso: null
}
export default {
  name: 'ModalBlockAjuizamento',
  props: {
    column: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      isEditing: null,
      form: ModalBlockAjuizamentoForm,
      data: dataBlockAjuizamento,
      boardColumn: null
    }
  },
  components: {},
  created () {},
  async mounted () {
    this.$nextTick(() => {
      if (this.$refs['modal-bloquear-ajuizamento']) {
        this.form.diasAtrasoProdutoCard.value = this.column.diasAtrasoProdutoCard
        this.showModal()
      }
    })
  },
  methods: {
    showModal () {
      this.$refs['modal-bloquear-ajuizamento'].show()
    },
    hideModal () {
      this.$emit('Reload')
    },
    onEdit (obj) {
      this.isEditing = obj
    },
    onClear () {
      this.$root.$emit('clearForm')
    },
    saveAndClose () {
      this.boardColumn = this.column
      this.boardColumn.diasAtrasoProdutoCard = parseInt(this.form.diasAtrasoProdutoCard.value)
      this.$parent.boardColumns[this.index] = this.boardColumn
      this.$emit('update', this.boardColumn.diasAtrasoProdutoCard)
    }
  }
}

</script>
<style lang="scss">
.formulate-input-element.formulate-input-element--textarea {
  max-width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/board/modal/block-ajuizamento/ModalBlockAjuizamento.vue